module.exports = __webpack_public_path__ + "img/img_customers_08.c6e902a4.png";